import apiClient from '@/services/axios'

export async function del(id) {
  var response = await apiClient.delete(process.env.VUE_APP_CRM_API_BASE_URL + '/EmailTemplates/?id=' + id)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete email template.')
}